module.exports = __webpack_public_path__ + "img/desconto-new.10262d0.png";